import { useQuery } from "@tanstack/react-query";
import $api from "../api/axios";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { useOrganizationStore } from "@/zapi-frontend/stores/organization";

export type TLanguageOption = { code: string; label: string };

// Maps a snippets language code to the project/case-brief language value used across the app.
export const LANGUAGE_CODE_TO_VALUE: Record<string, string> = {
  en: "english",
  jp: "japanese"
};

export const GET_LANGUAGES_KEY = "getLanguages";

export function useLanguages() {
  const role = useMeStore((s) => s.role);
  const currentOrganizationId = useOrganizationStore((s) => s.currentOrganizationId);

  const { data, isPending } = useQuery({
    queryKey: [GET_LANGUAGES_KEY, currentOrganizationId ?? null],
    queryFn: async () => {
      const { data } = await $api.get<{ data: TLanguageOption[] }>("/project-templates/languages", {
        params: currentOrganizationId ? { organizationId: currentOrganizationId } : undefined
      });
      return data.data;
    },
    enabled: !!role
  });

  return {
    languages: data ?? [],
    isLanguagesLoading: isPending
  };
}
